"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { useOverviewLayout } from "@/contexts/overview-layout-context";
import { OVERVIEW_SECTIONS, PatientOverviewProps } from "@/lib/overview-section-registry";
export default function OverviewTabReadView(props) {
  const $ = _c(9);
  const {
    state
  } = useOverviewLayout();
  let t0;
  let t1;
  if ($[0] !== props || $[1] !== state.saved) {
    const visible = state.saved.filter(_temp).sort(_temp2);
    t0 = "space-y-12";
    let t2;
    if ($[4] !== props) {
      t2 = p_0 => <Fragment key={p_0.section}>{OVERVIEW_SECTIONS[p_0.section].render(props)}</Fragment>;
      $[4] = props;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = visible.map(t2);
    $[0] = props;
    $[1] = state.saved;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <div className={t0}>{t1}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(a, b) {
  return a.position - b.position;
}
function _temp(p) {
  return p.visible;
}